<template>
  <div>
    <template v-if="place">
      <p class="page-subtitle">Dati anagrafici</p>

      <div class="form-group row">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >Ragione sociale</label
        >
        <div class="col-lg-10 col-md-8 col-12 my-auto">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="[/^company\.business_name$/]"
          />
          <inline-editor
            inputClasses="text-left borderless p-0 w-100"
            :disabled="disabled"
            :value="place.company.businessName"
            class="ml-auto my-auto"
            placeholder="ragione sociale"
            :dataKeys="[...companyNamespace, 'businessName']"
            @change="onDataUpdated"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >Sede legale</label
        >
        <div class="col-lg-10 col-md-8 col-sm-8 col-12 my-auto">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="[/^company\.address\..*$/]"
          />
          <inline-places-autocomplete
            class="ml-auto my-auto w-100"
            :disabled="disabled"
            :value="place.company.address.fullAddress"
            @selected="onDataUpdated"
            :dataKeys="[...this.companyNamespace, 'google_maps_location']"
          />
        </div>
        <div
          class="checkbox col-lg-4 col-md-4 offset-md-4 offset-lg-2"
          v-if="!place.company.address.streetNumber"
        >
          <label class="mb-0">
            <input
              type="checkbox"
              name="o3"
              v-model="place.company.address.missingStreetNumber"
              :disabled="disabled"
              :checked="place.company.address.missingStreetNumber"
              @input="onCompanyStreetNumberPresenceChanged"
            />
            <span class="cr">
              <i class="cr-icon fa fa-check"></i>
            </span>
            Numero civico mancante
          </label>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >Email</label
        >
        <div class="col-lg-10 col-md-8 col-12 my-auto">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="[/^company\.email$/]"
          />
          <inline-editor
            :regExp="emailRegExp"
            inputClasses="text-left borderless p-0 w-100"
            :disabled="disabled"
            :value="place.company.email"
            class="ml-auto my-auto"
            placeholder="email"
            :lowercase="true"
            :dataKeys="[...companyNamespace, 'email']"
            @change="onDataUpdated"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >PEC</label
        >
        <div class="col-lg-10 col-md-8 col-12 my-auto">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="[/^company\.pec$/]"
          />
          <inline-editor
            :regExp="emailRegExp"
            inputClasses="text-left borderless p-0 w-100"
            :disabled="disabled"
            :value="place.company.pec"
            class="ml-auto my-auto"
            :lowercase="true"
            placeholder="PEC"
            :dataKeys="[...companyNamespace, 'pec']"
            @change="onDataUpdated"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >Codice univoco</label
        >
        <div class="col-lg-10 col-md-8 col-12 my-auto">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="[/^company\.sdi$/]"
          />
          <inline-editor
            inputClasses="text-left borderless p-0 w-100"
            :value="place.company.sdi"
            :disabled="disabled"
            :regExp="sdiRegExp"
            :uppercase="true"
            class="ml-auto my-auto"
            placeholder="codice univoco"
            :dataKeys="[...companyNamespace, 'sdi']"
            @change="onDataUpdated"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >Telefono bar</label
        >
        <div class="col-lg-10 col-md-8 col-12 my-auto">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="[/^company\.phone$/]"
          />
          <inline-editor
            inputClasses="text-left borderless p-0 w-100"
            :value="place.company.phone"
            :disabled="disabled"
            class="ml-auto my-auto"
            placeholder="telefono bar"
            :dataKeys="[...companyNamespace, 'phone']"
            @change="onDataUpdated"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >Cellulare</label
        >
        <div class="col-lg-10 col-md-8 col-12 my-auto">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="[/^company\.mobile_phone$/]"
          />
          <inline-editor
            inputClasses="text-left borderless p-0 w-100"
            :value="place.company.mobilePhone"
            :disabled="disabled"
            class="ml-auto my-auto"
            placeholder="cellulare"
            :dataKeys="[...companyNamespace, 'mobilePhone']"
            @change="onDataUpdated"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >Codice fiscale</label
        >
        <div class="col-lg-10 col-md-8 col-12 my-auto">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="[/^company\.fiscal_code$/]"
          />
          <inline-editor
            :regExp="vatCodeRegExp"
            :maxLength="16"
            :uppercase="true"
            inputClasses="text-left borderless p-0 w-100"
            :disabled="disabled"
            :value="place.company.fiscalCode"
            class="ml-auto my-auto"
            placeholder="codice fiscale"
            :dataKeys="[...companyNamespace, 'fiscalCode']"
            @change="onDataUpdated"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >Partita IVA</label
        >
        <div class="col-lg-10 col-md-8 col-12 my-auto">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="[/^company\.vat_code$/]"
          />
          <inline-editor
            :regExp="vatCodeRegExp"
            :maxLength="16"
            :uppercase="true"
            inputClasses="text-left borderless p-0 w-100"
            :disabled="disabled"
            :value="place.company.vatCode"
            class="ml-auto my-auto"
            placeholder="partita IVA"
            :dataKeys="[...companyNamespace, 'vatCode']"
            @change="onDataUpdated"
          />
        </div>
      </div>

      <p class="page-subtitle mt-5 mb-3">Legale rappresentante</p>
      <div class="form-group row">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >Nome</label
        >
        <div class="col-lg-10 col-md-8 col-12 my-auto">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="[/^company\.contact\.first_name$/]"
          />
          <inline-editor
            inputClasses="text-left borderless p-0 w-100"
            :disabled="disabled"
            :value="place.company.contact.firstName"
            class="ml-auto my-auto"
            placeholder="nome"
            :dataKeys="[...this.companyContactNamespace, 'firstName']"
            @change="onDataUpdated"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >Cognome</label
        >
        <div class="col-lg-10 col-md-8 col-12 my-auto">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="[/^company\.contact\.last_name$/]"
          />
          <inline-editor
            inputClasses="text-left borderless p-0 w-100"
            :disabled="disabled"
            :value="place.company.contact.lastName"
            class="ml-auto my-auto"
            placeholder="cognome"
            :dataKeys="[...companyContactNamespace, 'lastName']"
            @change="onDataUpdated"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >Residenza</label
        >
        <div class="col-lg-10 col-md-8 col-sm-8 col-12 my-auto">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="[/^company\.contact\.address\..+$/]"
          />
          <inline-places-autocomplete
            :value="place.company.contact.address.fullAddress"
            :disabled="disabled"
            class="ml-auto my-auto w-100"
            @selected="onDataUpdated"
            :dataKeys="[...companyContactNamespace, 'google_maps_location']"
          />
        </div>
        <div
          class="checkbox col-lg-4 col-md-4 offset-md-4 offset-lg-2"
          v-if="!place.company.contact.address.streetNumber"
        >
          <label class="mb-0">
            <input
              type="checkbox"
              name="o3"
              v-model="place.company.contact.address.missingStreetNumber"
              :disabled="disabled"
              :checked="place.company.contact.address.missingStreetNumber"
              @input="onContactStreetNumberPresenceChanged"
            />
            <span class="cr">
              <i class="cr-icon fa fa-check"></i>
            </span>
            Numero civico mancante
          </label>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >Data di nascita</label
        >
        <div class="col-lg-10 col-md-8 col-12 my-auto">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="[/^company\.contact\.birth_date$/]"
          />
          <inline-editor
            inputClasses="text-left borderless p-0 w-100"
            :disabled="disabled"
            type="date"
            :formatter="dateFormatter"
            :value="place.company.contact.birthDate"
            class="ml-auto my-auto"
            placeholder="data di nascita"
            :dataKeys="[...companyContactNamespace, 'birthDate']"
            @change="onDataUpdated"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >Luogo di nascita</label
        >
        <div class="col-lg-10 col-md-8 col-12 my-auto">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="[/^company\.contact\.birth_place$/]"
          />
          <inline-editor
            inputClasses="text-left borderless p-0 w-100"
            :disabled="disabled"
            :value="place.company.contact.birthPlace"
            class="ml-auto my-auto"
            placeholder="luogo di nascita"
            :dataKeys="[...this.companyContactNamespace, 'birthPlace']"
            @change="onDataUpdated"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >Codice fiscale</label
        >
        <div class="col-lg-10 col-md-8 col-12 my-auto">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="[/^company\.contact\.fiscal_code$/]"
          />
          <inline-editor
            :regExp="vatCodeRegExp"
            :disabled="disabled"
            :maxLength="16"
            :uppercase="true"
            inputClasses="text-left borderless p-0 w-100"
            :value="place.company.contact.fiscalCode"
            class="ml-auto my-auto"
            placeholder="codice fiscale"
            :dataKeys="[...this.companyContactNamespace, 'fiscalCode']"
            @change="onDataUpdated"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >Telefono</label
        >
        <div class="col-lg-10 col-md-8 col-12 my-auto">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="[/^company\.contact\.phone$/]"
          />
          <inline-editor
            inputClasses="text-left borderless p-0 w-100"
            :disabled="disabled"
            :value="place.company.contact.phone"
            class="ml-auto my-auto"
            placeholder="telefono"
            :dataKeys="[...this.companyContactNamespace, 'phone']"
            @change="onDataUpdated"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import InlineEditor, { IDataFormatter } from "components/InlineEditor.vue";
import InlinePlacesAutocomplete from "components/Google/InlinePlacesAutocomplete.vue";
import { Place } from "models";
import * as moment from "moment";

@Component({ components: { InlineEditor, InlinePlacesAutocomplete } })
export default class PlaceContactData extends Vue {
  @Prop({ required: true })
  place!: Place;

  private dateFormatter: IDataFormatter = {
    fromString(value) {
      return value;
    },
    toString(value) {
      return moment(value).format("DD/MM/YYYY");
    },
  };

  companyNamespace = ["company"];
  companyContactNamespace = [...this.companyNamespace, "contact"];

  onDataUpdated(data) {
    this.$emit("updated", data);
  }

  onCompanyStreetNumberPresenceChanged() {
    this.$emit("updated", {
      company: {
        address: {
          missingStreetNumber: !this.place.company.address.missingStreetNumber
            ? "1"
            : "0",
        },
      },
    });
  }

  onContactStreetNumberPresenceChanged() {
    this.$emit("updated", {
      company: {
        contact: {
          address: {
            missingStreetNumber: !this.place.company.contact.address
              .missingStreetNumber
              ? "1"
              : "0",
          },
        },
      },
    });
  }

  @Prop({ default: false })
  disabled: boolean;

  emailRegExp = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
  vatCodeRegExp = new RegExp(
    "(^[0-9]{11}$)|(^[a-zA-Z]{6}[0-9]{2}[abcdehlmprstABCDEHLMPRST]{1}[0-9]{2}([a-zA-Z]{1}[0-9]{3})[a-zA-Z]{1}$)",
    "i",
  );
  fiscalCodeRegExp = new RegExp(
    "^[a-zA-Z]{6}[0-9]{2}[abcdehlmprstABCDEHLMPRST]{1}[0-9]{2}([a-zA-Z]{1}[0-9A-Z]{3})[a-zA-Z]{1}$",
    "i",
  );
  sdiRegExp = new RegExp("^[0-9a-zA-Z]{7}$", "i");
}
</script>

<style scoped></style>
